import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Card from '../../card'
import CardHeader from '../../card/cardHeader'
import CardImage from '../../card/cardHeader/cardImage'
import CardContent from '../../card/cardContent'
import logo from './assets/rocket.svg'
import abel from './assets/Abel.svg'
import alvaro from './assets/Alvaro.svg'
import damaris from './assets/Damaris.svg'
import dani from './assets/Dani.svg'
import felipe from './assets/Felipe.svg'
import hugo from './assets/Hugo.svg'
import javi from './assets/Javi.svg'
import mafe from './assets/Mafe.svg'
import manuel from './assets/Manuel.svg'
import noPhoto from './assets/no-photo.svg'

import styles from './_rocket.scss'

const Member = ({ pic, name, role }) => {
  return (
    <Fragment>
      <h2 className={styles['member__role']}>{role}</h2>
      <div className={styles['member']}>
        <img alt='avatar' src={pic || noPhoto} />
        <div className={styles['member-desc']}>
          <h1>{name}</h1>
        </div>
      </div>
    </Fragment>
  )
}

const Members = () => {
  const members = [
    {
      id: 1,
      key: 'PO',
      picture: null,
      name: 'Loreto Carrasco',
      role: 'Product Owner'
    },
    {
      id: 2,
      key: 'BA',
      picture: damaris,
      name: 'Dámaris Rodriguez',
      role: 'Bussiness Analyst'
    },
    {
      id: 3,
      key: 'SM',
      picture: felipe,
      name: 'Juan Felipe Arango',
      role: 'Scrum Master'
    },
    {
      id: 4,
      key: 'UX',
      picture: javi,
      name: 'Javiera Mardones',
      role: 'UX/UI Designer'
    },
    {
      id: 9,
      key: 'LT',
      picture: dani,
      name: 'Daniel Valdebenito',
      role: 'Technical Lead'
    },
    {
      id: 5,
      key: 'QA',
      picture: mafe,
      name: 'María Fernanda',
      role: 'QA'
    },
    {
      id: 6,
      key: 'SA',
      picture: hugo,
      name: 'Hugo Bustamante',
      role: 'Solution Arquitect'
    },
    {
      id: 8,
      key: 'FUSE',
      picture: manuel,
      name: 'Manuel Rodriguez',
      role: 'Fuse Developer'
    },
    {
      id: 10,
      key: 'FRONT',
      picture: abel,
      name: 'Abel Obando',
      role: 'Frontend Developer'
    },
    {
      id: 11,
      key: 'FRONT',
      picture: alvaro,
      name: 'Álvaro Troncoso',
      role: 'Frontend Developer'
    },
    {
      id: 12,
      key: 'RGP',
      picture: null,
      name: 'Alejandro Olmedo',
      role: 'RPG Developer'
    }
  ]

  return (
    <section className={styles['members']}>
      <h3>Nosotros somos</h3>
      <ul className={styles['members-list']}>
        {members.map((m) => (
          <div className={styles['members__member-box']}>
            <li key={m.id}>
              <Member
                pic={m.picture}
                name={m.name}
                role={m.role}
                key={m.key}
              />
            </li>
          </div>
        ))}
      </ul>
    </section>
  )
}

const RocketTeam = ({ members, showAs }) => {
  return (
    <Card selected>
      {showAs === 'card' && (
        <Fragment>
          <CardHeader>
            <CardImage alt='foto' imgUrl={logo} />
          </CardHeader>
          <CardContent
            className='card-content'
            title='Equipo Rocket'
            content='CREAMOS EXPERIENCIAS DIGITALES FINANCIERAS para las PERSONAS, con el objetivo de MEJORAR SU CALIDAD DE VIDA y la de su entorno'
          >
            <div className={styles['members-container']}>
              {members && <Members />}
            </div>
          </CardContent>
        </Fragment>
      )}
      {showAs === 'banner' && (
        <div className={styles['banner-layout']}>
          <img alt='foto' src={logo} />
          <div className={styles['banner-description']}>
            <h1>Equipo Rocket</h1>
            <p>
              CREAMOS EXPERIENCIAS DIGITALES FINANCIERAS para las PERSONAS, con
              el objetivo de MEJORAR SU CALIDAD DE VIDA y la de su entorno
            </p>
          </div>
        </div>
      )}
    </Card>
  )
}

RocketTeam.defaultProps = {
  members: true,
  showAs: 'card'
}

RocketTeam.propTypes = {
  members: PropTypes.bool,
  showAs: PropTypes.oneOf(['card', 'banner'])
}

export default RocketTeam
